/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Unlimited_ListingsInputs */

const en_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited Listings`)
};

const es_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios ilimitados`)
};

const fr_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces illimitées`)
};

const de_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Inserate`)
};

const ja_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品数無制限`)
};

const zh_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限制商品发布`)
};

const ar_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلانات غير محدودة`)
};

const id_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Tak Terbatas`)
};

const it_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annunci Illimitati`)
};

const ru_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безлимитные объявления`)
};

const pt_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anúncios Ilimitados`)
};

const ko_pricing_feature_unlimited_listings = /** @type {(inputs: Pricing_Feature_Unlimited_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무제한 상품 등록`)
};

/**
* | output |
* | --- |
* | "Unlimited Listings" |
*
* @param {Pricing_Feature_Unlimited_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_unlimited_listings = /** @type {((inputs?: Pricing_Feature_Unlimited_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Unlimited_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_unlimited_listings(inputs)
	if (locale === "es") return es_pricing_feature_unlimited_listings(inputs)
	if (locale === "fr") return fr_pricing_feature_unlimited_listings(inputs)
	if (locale === "de") return de_pricing_feature_unlimited_listings(inputs)
	if (locale === "ja") return ja_pricing_feature_unlimited_listings(inputs)
	if (locale === "zh") return zh_pricing_feature_unlimited_listings(inputs)
	if (locale === "ar") return ar_pricing_feature_unlimited_listings(inputs)
	if (locale === "id") return id_pricing_feature_unlimited_listings(inputs)
	if (locale === "it") return it_pricing_feature_unlimited_listings(inputs)
	if (locale === "ru") return ru_pricing_feature_unlimited_listings(inputs)
	if (locale === "pt") return pt_pricing_feature_unlimited_listings(inputs)
	return ko_pricing_feature_unlimited_listings(inputs)
});